import Header from '../components/Header/Header'
import Hero from '../components/Hero/Hero'
import AchievementsSection from '../components/AchievementsSection/AchievementsSection'
import PromoBanner from '../components/PromoBanner/PromoBanner'
import CoursesSection from '../components/CoursesSection/CoursesSection'
import ConsultationBanner from '../components/ConsultationBanner/ConsultationBanner'
import AdvantagesSection from '../components/AdvantagesSection/AdvantagesSection'
import TeamSlider from '../components/TeamSlider/TeamSlider'
import ProjectsSection from '../components/ProjectsSection/ProjectsSection'
import FormSection from '../components/FormSection/FormSection'
import ServicesSection from '../components/ServicesSection/ServicesSection'
import ReviewsSection from '../components/ReviewsSection/ReviewsSection'
import GallerySection from '../components/GallerySection/GallerySection'
import FAQSection from '../components/FAQSection/FAQSection'
import ContactsSection from '../components/ContactsSection/ContactsSection'
import FooterSection from '../components/FooterSection/FooterSection'
import PromoModal from '../components/PromoModal/PromoModal'
import RatingSection from '../components/RatingSection/RatingSection'

import FadeIn from '../components/FadeIn/FadeIn' 
import './Home.css'

function Home () {
    return (
        <div className='backphoto'>
            <div className='container'>
                <Header />
                <FadeIn direction="up">
                    <Hero />
                </FadeIn>
            </div>

            {/* Выезжает классически снизу */}
            <FadeIn direction="right">
                <AchievementsSection />
            </FadeIn>

            <div className='container'>
                {/* Баннер плавно увеличивается (scale) */}
                <FadeIn direction="scale">
                    <PromoBanner />
                </FadeIn>
                
                {/* Курсы выезжают слева */}
                <FadeIn direction="left">
                    <CoursesSection />
                </FadeIn>
                
                {/* Баннер консультации выезжает справа */}
                <FadeIn direction="up">
                    <ConsultationBanner />
                </FadeIn>
                
                <FadeIn direction="rigth">
                    <AdvantagesSection />
                </FadeIn>
                
                <FadeIn direction="scale">
                    <TeamSlider />
                </FadeIn>
            </div>

            <FadeIn direction="left">
                <ProjectsSection />
            </FadeIn>

            <div className='container'>
                <FadeIn direction="up">
                    <ServicesSection />
                </FadeIn>
                
                <FadeIn direction="right">
                    <ReviewsSection />
                </FadeIn>
                
                {/* Форму тоже можно плавно увеличить */}
                <FadeIn direction="scale">
                    <FormSection />
                </FadeIn>
                
                <FadeIn direction="left">
                    <GallerySection />
                </FadeIn>
                
                <FadeIn direction="rigth">
                    <FAQSection />
                </FadeIn>
                
                <FadeIn direction="scale">
                    <RatingSection />
                </FadeIn>
                
                <FadeIn direction="up">
                    <ContactsSection />
                </FadeIn>
            </div>

            <FooterSection />
            <PromoModal />
        </div>
    )
}

export default Home
